import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const TranslationsDebug = require('./translation/debug.json').translations;
const TranslationsEnUs = require('./translation/en-US.json').translations;
const TranslationsEsUs = require('./translation/es-US.json').translations;

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en-US',
        debug: false,

        keySeparator: '.',

        interpolation: {
            escapeValue: false,
            formatSeparator: ',',
        },

        react: {
            useSuspense: false,
            bindI18n: 'languageChanged',
        },

        resources: {
            'en-US': {
                translations: TranslationsEnUs,
            },
            'es-US': {
                translations: TranslationsEsUs,
            },
            debug: {
                translations: TranslationsDebug,
            },
        },
        ns: ['translations'],
        defaultNS: 'translations',
    });

export default i18n;
